export default __webpack_public_path__ + "static/media/CLYBYMATTHEW_20230318_0027_MR1_8181.2132cf08.jpg";